var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_28630)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 8,
    fill: "url(#paint0_linear_269_28630)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3998 7.05536H9.6014C8.19574 7.05536 7.05615 8.19489 7.05615 9.6006V23.399C7.05615 24.8048 8.19568 25.9442 9.6014 25.9442H16.4066L16.4184 19.1946H14.6646C14.4367 19.1946 14.2517 19.0103 14.251 18.7824L14.2424 16.6065C14.2415 16.3775 14.4272 16.1912 14.6562 16.1912H16.4068V14.0888C16.4068 11.6492 17.8969 10.3207 20.0732 10.3207H21.8592C22.0875 10.3207 22.273 10.506 22.273 10.7345V12.569C22.273 12.7976 22.0877 12.9828 21.8594 12.9828L20.7633 12.9835C19.5798 12.9835 19.3505 13.5458 19.3505 14.3713V16.1914H21.9512C22.1992 16.1914 22.3914 16.4079 22.3621 16.6537L22.1042 18.8296C22.0797 19.0379 21.903 19.1947 21.6933 19.1947H19.3622L19.3504 25.9446H23.3997C24.8054 25.9446 25.945 24.805 25.945 23.3993V9.6006C25.945 8.19495 24.8054 7.05536 23.3998 7.05536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4066 25.9441L16.4185 19.1945H16.3894V25.9441H16.4066Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_28630",
    x1: 16.5,
    y1: 0,
    x2: 16.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E598F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24306D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_28630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3be28b08da861b4f80e83194adf4ada1.svg";
export { ForwardRef as ReactComponent };